export const SendTextMessage = 'send text message';
export const FilterByPatientRequest = 'filter tasks by patient request';
export const AddNewPatient = 'add new patient';
